import config from 'config';
import { RSAA } from 'redux-api-middleware';

import { CACHE_ONE_HOUR, isValidCache } from 'shared/utils/cacheUtils';
import { ANALYSIS_SITES } from 'sport/constants/sportConstants';

import * as types from '../actionTypes';
import { calendar } from '../selectors';

export function fetchAtgCalendar() {
  return {
    [RSAA]: {
      bailout: state =>
        isValidCache(
          calendar.atgCalendarSelector(state).timestamp,
          CACHE_ONE_HOUR,
        ),
      endpoint: 'calendar/fetchCalendar',
      types: [
        types.REQUEST_ATG_CALENDAR,
        types.RECEIVE_ATG_CALENDAR,
        {
          type: types.RECEIVE_ATG_CALENDAR_ERROR,
          meta: { errorType: 'discrete' },
        },
      ],
    },
  };
}

export function fetchSportCalendar() {
  return {
    [RSAA]: {
      bailout: state =>
        isValidCache(
          calendar.sportCalendarSelector(state).timestamp,
          CACHE_ONE_HOUR,
        ),
      endpoint: 'sportCalendar/fetchCalendar',
      types: [
        types.REQUEST_SPORT_CALENDAR,
        types.RECEIVE_SPORT_CALENDAR,
        {
          type: types.RECEIVE_SPORT_CALENDAR_ERROR,
          meta: { errorType: 'discrete' },
        },
      ],
    },
  };
}

export function fetchAtgJackpots() {
  return {
    [RSAA]: {
      bailout: state =>
        isValidCache(
          calendar.atgJackpotsSelector(state).timestamp,
          CACHE_ONE_HOUR,
        ),
      endpoint: 'calendar/fetchJackpots',
      types: [
        types.REQUEST_ATG_JACKPOTS,
        types.RECEIVE_ATG_JACKPOTS,
        {
          type: types.RECEIVE_ATG_JACKPOTS_ERROR,
          meta: { errorType: 'discrete' },
        },
      ],
    },
  };
}

export function fetchSportJackpots() {
  return {
    [RSAA]: {
      bailout: state =>
        isValidCache(
          calendar.sportJackpotsSelector(state).timestamp,
          CACHE_ONE_HOUR,
        ),
      endpoint: 'sportCalendar/fetchJackpots',
      types: [
        types.REQUEST_SPORT_JACKPOTS,
        types.RECEIVE_SPORT_JACKPOTS,
        {
          type: types.RECEIVE_SPORT_JACKPOTS_ERROR,
          meta: { errorType: 'discrete' },
        },
      ],
    },
  };
}

export function fetchSportAnalysis() {
  return dispatch =>
    Promise.all(
      Object.keys(ANALYSIS_SITES).map(site =>
        dispatch({
          [RSAA]: {
            bailout: state =>
              isValidCache(
                calendar.sportAnalysisSelector(state)[site]?.timestamp,
                CACHE_ONE_HOUR,
              ),
            endpoint: `${config.trsportApi}/v1/svenskaspel/rounds/latest?external=true`,
            method: 'GET',
            headers: {
              'TRMedia-API-Key': config.trMediaApiKey,
              site,
            },
            types: [
              {
                type: types.REQUEST_SPORT_ANALYSIS,
                meta: { site },
              },
              {
                type: types.RECEIVE_SPORT_ANALYSIS,
                meta: { site },
              },
              {
                type: types.RECEIVE_SPORT_ANALYSIS_ERROR,
                meta: { errorType: 'discrete', site },
              },
            ],
          },
        }),
      ),
    );
}

export function changeSportSectionVisibility(visible) {
  return {
    type: types.CHANGE_SPORT_SECTION_VISIBILITY,
    payload: visible,
    meta: {
      persist: 'local',
    },
  };
}

export function changeAtgSectionVisibility(visible) {
  return {
    type: types.CHANGE_ATG_SECTION_VISIBILITY,
    payload: visible,
    meta: {
      persist: 'local',
    },
  };
}

export function changeAtgListVisibility(visible) {
  return {
    type: types.CHANGE_ATG_LIST_VISIBILITY,
    payload: visible,
    meta: {
      persist: 'local',
    },
  };
}

export function changeSportListVisibility(visible) {
  return {
    type: types.CHANGE_SPORT_LIST_VISIBILITY,
    payload: visible,
    meta: {
      persist: 'local',
    },
  };
}
